import React, { useState, useEffect } from 'react';
import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';
import Footer from './Footer.jsx';
import ChatbotWidget from './ChatbotWidget.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import './Layout.css';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const isAdmin = ['admin', 'super_admin'].includes(String(user?.role || '').toLowerCase().trim());

  const getIsMobile = () => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 768;
  };

  // Persistent sidebar by default on desktop (standard SaaS shell); a fresh
  // mobile visit still starts as a closed drawer.
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebarOpen');
    if (saved !== null) return JSON.parse(saved);
    return !getIsMobile();
  });
  const [isMobile, setIsMobile] = useState(getIsMobile);

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', JSON.stringify(newState));
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
    localStorage.setItem('sidebarOpen', JSON.stringify(false));
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Optional: Save state whenever it changes
  useEffect(() => {
    localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen));
  }, [sidebarOpen]);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
      localStorage.setItem('sidebarOpen', JSON.stringify(false));
    }
  }, [isMobile]);

  return (
    <div className="layout">
      <Header onToggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} onItemClick={closeSidebar} />
      {isMobile && sidebarOpen && <div className="sidebar-backdrop" onClick={closeSidebar}></div>}
      <main className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
        {children}
        <Footer />
      </main>
      {isAdmin && <ChatbotWidget />}
    </div>
  );
};

export default Layout;